export function num2string (num) {
  if (!num) {
    return ''
  }
  const val = isNaN(num) ? '' : (+num).toFixed(2)
  return val.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,')
}
